var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CarRegion',{attrs:{"ListCarData":_vm.alldatas,"listCar":_vm.listCar,"reginName":_vm.reginName,"getSeachCar":_vm.getSeachCar}}),_c('CarTypeRegion',{attrs:{"pieData":_vm.alldatas,"reginName":_vm.reginName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }